import {createSelector} from 'reselect'
import {getTypesOfWork} from "../entities/selectors";
import {typeOfWorkComparator} from "./utils";

export const getSortedTypeOfWorkList = createSelector(
    getTypesOfWork,
    (typesOfWork) => Object.values(typesOfWork).sort(typeOfWorkComparator)
)


// WEBPACK FOOTER //
// ./web/js/typesOfWork/selectors.js